import { RFValue } from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
   border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  margin:0 -24px;
padding:0 24px;
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;

`;
export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-bottom: ${RFValue(12)}px;
`;
